import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {useMediaQuery} from "@mui/material";
import {useUserStore} from "../stores/userStore";
import {useNavigate} from "react-router-dom";
import {useApplicantStore} from "../stores/applicantStore";
import {useApplicantCheck} from "../hooks/useApplicantCheck";
import {useEffect, useState} from "react";

const SelectApplicantComponent = () => {
    const applicantStore = useApplicantStore();
    const userStore = useUserStore();
    const navigate = useNavigate();
    //@ts-ignore
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'));

    const [selectedApplicant, setSelectedApplicant] = useState<number>();
    const {applicant} = useApplicantCheck(selectedApplicant);

    useEffect(() => {
        if (!applicant) return;
        setSelectedApplicant(applicant?.id);
    }, [applicant]);

    //@ts-ignore
    const handleChangeApplicant = (e) => {
        setSelectedApplicant(e.target.value);
        navigate(`/parties/${e.target.value}`);
    }

    if (!userStore.user) return null;
    return (
            <Select
                    value={selectedApplicant ?? ""}
                    label="Applicants"
                    onChange={handleChangeApplicant}
                    sx={{color: matches ? "white" : "black", border: "white", maxWidth: 250, minWidth: 100}}
            >
                {userStore.user.applicants.map(item => {
                    return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                })}
            </Select>
    )
}

export default SelectApplicantComponent;